// src/Components/HighLevelComponents/Tool/ToolResults.tsx
import React from "react";
import { HashLoader } from "react-spinners";
import { ToolRendererProps } from "./types";

interface ToolResultsProps {
  title: string;
  isGenerating: boolean;
  isStreaming: boolean;
  results: any[];
  ResultRenderer: React.ComponentType<ToolRendererProps>;
  toolId: string;
}

const ToolResults: React.FC<ToolResultsProps> = ({
  title,
  isGenerating,
  isStreaming,
  results,
  ResultRenderer,
  toolId,
}) => {
  const resultsRef = React.useRef<HTMLDivElement>(null);

  if (!isGenerating && results.length === 0) {
    return null;
  }

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-semibold text-gray-800">Results</h2>
      </div>

      {isGenerating && isStreaming && (
        <div className="flex justify-center items-center py-8">
          <HashLoader size={30} color="#FFC60B" />
          <span className="ml-3 text-gray-600">Generating results...</span>
        </div>
      )}

      <div ref={resultsRef}>
        {results.length > 0 && (
          <ResultRenderer results={results} isLoading={isGenerating} />
        )}
      </div>
    </div>
  );
};

export default ToolResults;
